import React from "react";
// Limitless imports
import { useGraphAPIHook } from "@limitless/portal";
import { useExpertProfileContext } from "@limitless/expert";
const INITIAL_STATE = {
  guide: [],
  loading: true,
  hasError: false
};
const LOAD_GUIDE_CONFIG = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "getUserGuide"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getUserGuide"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "sections"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "chapters"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "activePage"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "pages"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "image"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "text"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 377,
    "source": {
      "body": "\n    query getUserGuide {\n        getUserGuide {\n            sections {\n                id\n                title\n                chapters {\n                    id\n                    activePage\n                    title\n                    pages {\n                        image\n                        text\n                    }\n                }\n            }\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
const UPDATE_GUIDE_PROGRESS = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateGuideProgress"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "sectionId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "chapterId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "activePage"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateGuideProgress"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "sectionId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "sectionId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "chapterId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "chapterId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "activePage"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "activePage"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "result"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "successCount"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "failureCount"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 283,
    "source": {
      "body": "\n    mutation updateGuideProgress($sectionId: String!, $chapterId: String!, $activePage: Int!) {\n        updateGuideProgress(sectionId: $sectionId, chapterId: $chapterId, activePage: $activePage) {\n            result\n            successCount\n            failureCount\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const useHelpPanel = () => {
  const [guideConfig, setGuideConfig] = React.useState(INITIAL_STATE);
  const {
    fetchData,
    mutateData
  } = useGraphAPIHook();
  const {
    setHelpGuideAvailable
  } = useExpertProfileContext();
  React.useEffect(() => {
    if (guideConfig.guide.length === 0) {
      loadHelpConfig();
    }
  }, []);
  const loadHelpConfig = () => {
    setGuideConfig({
      ...guideConfig,
      loading: true
    });
    const options = {
      dataKey: "getUserGuide",
      query: LOAD_GUIDE_CONFIG,
      functionName: "HelpPanelHook loadHelpConfig"
    };
    fetchData(options).then(result => {
      setHelpGuideAvailable(true);
      setGuideConfig({
        guide: result,
        loading: false
      });
    }).catch(() => {
      setHelpGuideAvailable(false);
      setGuideConfig({
        ...INITIAL_STATE,
        hasError: true
      });
    });
  };
  const updateGuideProgress = (sectionId, chapterId, activePage, callback = () => null) => {
    const options = {
      dataKey: "updateGuideProgress",
      mutation: UPDATE_GUIDE_PROGRESS,
      variables: {
        sectionId,
        chapterId,
        activePage
      },
      functionName: "HelpPanelHook updateGuideProgress",
      notifyDetails: {
        actionName: "Update User Guide Progress",
        errorNotification: "Failed to update progress"
      },
      postSuccessFunction: callback
    };
    mutateData(options);
  };
  const updateActivePage = (guideSectionIndex, chapterIndex, direction) => {
    const localGuideSections = [...guideConfig.guide.sections];
    localGuideSections[guideSectionIndex].chapters[chapterIndex].activePage += direction;
    const sectionId = localGuideSections[guideSectionIndex].id;
    const chapterId = localGuideSections[guideSectionIndex].chapters[chapterIndex].id;
    const activePage = localGuideSections[guideSectionIndex].chapters[chapterIndex].activePage;
    setGuideConfig({
      guide: {
        sections: localGuideSections
      },
      loading: false
    });
    updateGuideProgress(sectionId, chapterId, activePage);
  };
  return {
    guideConfig,
    updateActivePage
  };
};